/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddSendSafelyRecipientRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {AddSendSafelyRecipientResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const addSendSafelyRecipient = (request: AddSendSafelyRecipientRequest, options?: CashRequestOptions) => post<AddSendSafelyRecipientRequest, AddSendSafelyRecipientResponse>("/2.0/cash/add-send-safely-recipient", request, {...options, rejectOnError: true })